import React, { useState, useEffect, useContext } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../../constant";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";

const DevicePropertyList = () => {
  const { header, id } = useParams();
  const { t } = useTranslation();
  const { authCtx, darkMode } = useContext(AppContext);
  const navigate = useNavigate();

  const onEditClick = (e) => {
    navigate(`/devicepropertyform/${header}/${id}/${e.dataItem.id}`);
  };

  const EditRow = (e) => {
    return (
      <td className="">
        <button
          className="flex flex-col justify-center items-center gap-1 px-3"
          onClick={() => onEditClick(e)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
            />
          </svg>
        </button>
      </td>
    );
  };

  const boolColumn = (props) => {
    return (
      <td>
        {props.dataItem.active === true ? (
          <div className=" text-green-600 py-2 px-4">Active</div>
        ) : (
          <div className=" text-orange-600 py-2 px-4">Inactive</div>
        )}
      </td>
    );
  };

  const [deviceData, setDeviceData] = React.useState([]);
  const [details, setDetails] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const loadColumns = async () => {
    let res = await axios.get(`${BASE_URL}/DeviceType/${id}`);
    const data = res.data;
    setDetails(data);
  };

  const loadData = async () => {
    setLoading(true);
    const companyId =
      // authCtx.profile.role !== 100
      //   ?
      authCtx.profile?.companyId;
    // : superAdminCompany.id;
    const resData = await axios.get(
      `${BASE_URL}/api/Device?deviceTypeId=${id}&companyId=${companyId}&userRole=${authCtx.profile.role}`
    );
    setDeviceData(resData.data);
    setFilteredData(resData.data);
    setLoading(false);
  };

  const onCloseClick = (e) => {
    navigate(`/settings`);
  };

  const onSearch = (e) => {
    if (e.target.value === "") {
      setFilteredData(deviceData);
    } else {
      setFilteredData(
        deviceData.filter((s) =>
          s.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
    setSearch(e.target.value);
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    loadColumns();
  }, []);

  return (
    <div className="flex flex-col text-white px-14 py-7 dark:bg-darkModeBg bg-lightModeBg h-full">
      <div className="flex text-xs lg:text-lg font-medium gap-3 items-center pb-2 dark:text-white text-labels">
        <button type="button" onClick={onCloseClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2.0"
            stroke="currentColor"
            className="w-7 h-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
            />
          </svg>
        </button>
        <label className="dark:text-white text-labels">
          {t("masters.headerTexts.deviceMaster")}
        </label>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex text-xs lg:text-sm font-medium gap-3 items-center">
            <label className="dark:text-white text-labels">{header}</label>
          </div>
          <hr className="rotate-90 w-10 h-1 dark:border-zinc-800 border-labels"></hr>
          <label className="dark:text-zinc-600 text-labels text-xs lg:text-sm font-medium">
            {details?.manufacturer}
          </label>
          <div>
            <form>
              <div className="relative dark:bg-gray-900 bg-gray2 w-40 lg:w-80 h-9 rounded-lg dark:border-zinc-800 ml-3">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 text-neutral-700"
                    fill="none"
                    stroke={darkMode ? "white" : "black"}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  name="Search"
                  value={search}
                  className="block h-full pl-10 w-full text-xs lg:text-sm font-normal bg-inherit dark:text-white text-inputFieldsTxts dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts rounded-lg"
                  placeholder="Search"
                  onChange={onSearch}
                  required
                />
              </div>
            </form>{" "}
          </div>
        </div>
        <div className="flex dark:text-white text-labels">
          <button
            type="button"
            onClick={() => navigate(`/devicepropertyform/${header}/${id}/new`)}
            className="flex text-xs lg:text-sm font-medium h-9 dark:bg-indigo-700 bg-addNewItemBtns rounded-4xl justify-center items-center gap-1 leading-4 px-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {t("button.addNew")} {header}
          </button>
        </div>
      </div>
      <div
        className={`h-5/6 mt-4 w-full mb-16 relative ${
          darkMode ? "darkGrid" : "lightGrid"
        }`}
      >
        {loading && <KendoLoadingPanel />}
        <Grid
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#181921",
            borderRadius: "15px",
            textAlign: "justify",
            overflowY: "auto",
            scrollbarGutter: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "auto",
          }}
          data={filteredData}
        >
          <GridColumn
            key="deviceId"
            field="deviceId"
            title={t("masters.fields.deviceId")}
            filterable={false}
            // cell={column.cell}
            width="auto"
            className="product-name"
          />
          <GridColumn
            key="name"
            field="name"
            title={t("masters.fields.name")}
            filterable={false}
            // cell={column.cell}
            width="auto"
            className="product-name"
          />
          <GridColumn
            key="Active"
            field="active"
            title={t("masters.fields.active")}
            filterable={false}
            cell={boolColumn}
            width="auto"
            className="product-name pl-10"
          />
          <GridColumn
            key="Edit"
            field="Action"
            title={t("masters.fields.action")}
            filterable={false}
            cell={EditRow}
            width="180"
            className="product-name"
          />
        </Grid>
        {/* // )} */}
        <br />
      </div>
    </div>
  );
};

export default DevicePropertyList;
